
/**
 * 토픽 기본 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenBasicInfoAllOfTwo = {
  title: string;
};
